import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router/index.js'
import { installAudioUnlockListeners } from './utils/audio-unlock.js'

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'medium' }); //small指的是小尺寸，官方提供了3种尺寸small，mini，默认，通常用small

/* 全局变量 */
/* Vue.prototype.$globalVar = 'some value';
Vue.prototype.$token = '123'; */
//Vue.prototype.$authority = '1';

// 定义全局方法
Vue.prototype.$hasPermission = function (tag) {
	Vue.prototype.$authority = JSON.parse(sessionStorage.getItem('myValue'));
	for (var i = 0; i < Vue.prototype.$authority.length; i++){
		//console.log(Vue.prototype.$authority[i].name);
		if(tag == Vue.prototype.$authority[i].tag){
			return Vue.prototype.$authority[i].visible;
		}
		for (var j = 0; j < Vue.prototype.$authority[i].list.length; j++){
			//console.log(Vue.prototype.$authority[i].list[j].name);
			if(tag == Vue.prototype.$authority[i].list[j].tag){
				return Vue.prototype.$authority[i].list[j].visible;
			}
			for (var k = 0; k < Vue.prototype.$authority[i].list[j].list.length; k++){
				//console.log(Vue.prototype.$authority[i].list[j].list[k].name);
				if(tag == Vue.prototype.$authority[i].list[j].list[k].tag){
					return Vue.prototype.$authority[i].list[j].list[k].visible;
				}
			}
		}
	}
};
Vue.prototype.$setAuthority = function (authority) {
  Vue.prototype.$authority = authority;
  sessionStorage.setItem('myValue', JSON.stringify(Vue.prototype.$authority));
};

// 注册一次：用户交互后解锁音频播放权限（解决 NotAllowedError）
installAudioUnlockListeners();

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
